/* eslint eqeqeq: 'off' */  // --> OFF

import { useMemo } from 'react'

import { AccordionIcon } from '..'
import { Tasas } from './components'
import { CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormLabel, InputLista, InputListaMulti, InputNumber, Select, FormError } from '../../../../components/common'
import { OPERATION_MODE, TRIBUTO_TYPE } from '@laramie/ui';
import {TIPS} from "../../../../consts/tips";
import { TRATAMIENTO_PAGOS_TYPE } from '../../../../consts/tratamientoPagosType'

const CondicionesAplicacion = ({ toggle, open, formValues, handleInputProxy, errorOf, params, otherValues, setOtherValues, setPendingChange }) => {

    const aplicaDeudaValue = useMemo(() => {
        if (formValues.aplicaDeudaAdministrativa && formValues.aplicaDeudaLegal) return 1
        if (formValues.aplicaDeudaAdministrativa) return 2
        return 3
    }, [formValues.aplicaDeudaAdministrativa, formValues.aplicaDeudaLegal])
    const onAplicaDeudaChange = ({ target: { value }}) => {
        handleInputProxy({ target: { name: 'aplicaDeudaAdministrativa', value: value == 1 || value == 2 }})
        handleInputProxy({ target: { name: 'aplicaDeudaLegal', value: value == 1 || value == 3 }})
        if (value != 2 && formValues.idTipoTratamientoPagos === TRATAMIENTO_PAGOS_TYPE.APLICACION_DEUDA_ORIGINAL) {
            handleInputProxy({ target: { name: 'idTipoTratamientoPagos', value: 0 }})
        }
    }

    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon {...{open}} />
                        <h3 className={open ? 'active' : ''}>Condiciones de aplicación</h3>
                    </div>
                </div>
            </div>
        </div>
        {open && (
            <div className='accordion-body'>
                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="aplicaDeuda" className="form-label">Deuda aplicable</label>
                        <div className="d-flex gap-2 align-items-center">
                            <Select
                                name="aplicaDeuda"
                                className="form-control"
                                value={aplicaDeudaValue}
                                options={[
                                    { value: 1, label: 'Todo tipo de deuda' },
                                    { value: 2, label: 'Deuda administrativa' },
                                    { value: 3, label: 'Deuda judicializada' },
                                ]}
                                onChange={onAplicaDeudaChange}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                            <CheckboxButton
                                name="aplicaTotalidadDeudaAdministrativa"
                                label="Toda la deuda"
                                checked={formValues.aplicaTotalidadDeudaAdministrativa}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-3 col-lg-2">
                        <label htmlFor="montoDeudaAdministrativaDesde" className="form-label">Monto mínimo aplicable</label>
                        <InputNumber
                            name="montoDeudaAdministrativaDesde"
                            placeholder=""
                            className="form-control"
                            value={formValues.montoDeudaAdministrativaDesde}
                            onChange={handleInputProxy}
                            precision={2}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    <div className="col-12 col-md-3 col-lg-2">
                        <label htmlFor="montoDeudaAdministrativaHasta" className="form-label">Monto máximo aplicable</label>
                        <InputNumber
                            name="montoDeudaAdministrativaHasta"
                            placeholder=""
                            className="form-control"
                            value={formValues.montoDeudaAdministrativaHasta}
                            onChange={handleInputProxy}
                            precision={2}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    {[TRIBUTO_TYPE.COMERCIOS, TRIBUTO_TYPE.FONDEADEROS].includes(formValues.idTipoTributo) &&
                    <div className="col-12 col-md-auto col-lg-3 align-self-end">
                        <CheckboxButton
                            name="noAplicaDeudoresDDJJ"
                            label="No aplica para deudores de DDJJs"
                            checked={formValues.noAplicaDeudoresDDJJ}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>}
                    <InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Tipo condición especial'
                        tipName={TIPS.NAME.MODALS.TIPO_CONDICION_ESPECIAL_MODAL}
                        name='TipoCondicionEspecial'
                        type='entidad'
                        idField='idTipoCondicionEspecial'
                        data={otherValues.planPagosDefinicionAlcanceTipoCondicionEspecial}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceTipoCondicionEspecial: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />
                    {/*<InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Condición fiscal'
                        tipName={TIPS.NAME.MODALS.CONDICION_FISCAL_MODAL}
                        name='CondicionFiscal'
                        type='lista'
                        idField='idCondicionFiscal'
                        data={otherValues.planPagosDefinicionAlcanceCondicionFiscal}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceCondicionFiscal: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />*/}
                    {/*<InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Forma jurídica'
                        tipName={TIPS.NAME.MODALS.FORMA_JURIDICA_MODAL}
                        name='FormaJuridica'
                        type='lista'
                        idField='idFormaJuridica'
                        data={otherValues.planPagosDefinicionAlcanceFormaJuridica}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceFormaJuridica: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />*/}
                    {formValues.idTipoTributo === TRIBUTO_TYPE.COMERCIOS && <InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Rubros de comercio'
                        tipName={TIPS.NAME.MODALS.RUBROS_COMERCIO_MODAL}
                        name='Rubro'
                        type='entidad'
                        key='Rubro'
                        idField='idRubro'
                        data={otherValues.planPagosDefinicionAlcanceRubro}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceRubro: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />}
                    <InputListaMulti
                        className="col-12 col-md-6 col-lg-2"
                        title='Zonas tarifarias'
                        tipName={TIPS.NAME.MODALS.ZONAS_TARIFARIAS_MODAL}
                        name='ZonaTarifaria'
                        type='entidad'
                        idField='idZonaTarifaria'
                        data={otherValues.planPagosDefinicionAlcanceZonaTarifaria}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceZonaTarifaria: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />
                    {/*<InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Grupos'
                        tipName={TIPS.NAME.MODALS.GRUPO_MODAL}
                        name='Grupo'
                        type='entidad'
                        idField='idGrupo'
                        data={otherValues.planPagosDefinicionAlcanceGrupo}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceGrupo: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />*/}
                    {/*<InputListaMulti
                        className="col-12 col-md-6 col-lg-3"
                        title='Rubros AFIP'
                        tipName={TIPS.NAME.MODALS.RUBROS_AFIP_MODAL}
                        name='RubroAfip'
                        type='lista'
                        idField='idRubroAfip'
                        data={otherValues.planPagosDefinicionAlcanceRubroAfip}
                        setData={data => {setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceRubroAfip: data})); setPendingChange(true)}}
                        newItemFiller={{ idPlanPagoDefinicion: parseInt(params.id) }}
                        disabled={params.mode === OPERATION_MODE.VIEW}
					/>*/}
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="idTipoAlcanceTemporal" required>Tipo alcance temporal</FormLabel>
                        <InputLista
                            name="idTipoAlcanceTemporal"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoAlcanceTemporal') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoAlcanceTemporal}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            lista="TipoAlcanceTemporal"
                        />
                        <FormError message={errorOf('idTipoAlcanceTemporal')} />
                    </div>
                    {formValues.idTipoAlcanceTemporal === 420 && <>
                        <div className="col-12 col-lg-2">
                            <label htmlFor="fechaDesdeAlcanceTemporal" className="form-label">Fecha desde</label>
                            <DatePickerCustom
                                name="fechaDesdeAlcanceTemporal"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaDesdeAlcanceTemporal}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                        </div>
                        <div className="col-12 col-lg-2">
                            <label htmlFor="fechaHastaAlcanceTemporal" className="form-label">Fecha hasta</label>
                            <DatePickerCustom
                                name="fechaHastaAlcanceTemporal"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaHastaAlcanceTemporal}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                                minValue={formValues.fechaDesdeAlcanceTemporal}
                            />
                        </div>
                    </>}
                    {formValues.idTipoAlcanceTemporal === 421 && <>
                        <div className="col-12 col-lg-1">
                            <label htmlFor="mesDesdeAlcanceTemporal" className="form-label">Mes desde</label>
                            <InputNumber
                                name="mesDesdeAlcanceTemporal"
                                placeholder=""
                                className="form-control"
                                value={formValues.mesDesdeAlcanceTemporal}
                                onChange={handleInputProxy}
                                precision={0}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                        </div>
                        <div className="col-12 col-lg-1">
                            <label htmlFor="mesHastaAlcanceTemporal" className="form-label">Mes hasta</label>
                            <InputNumber
                                name="mesHastaAlcanceTemporal"
                                placeholder=""
                                className="form-control"
                                value={formValues.mesHastaAlcanceTemporal}
                                onChange={handleInputProxy}
                                precision={0}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
						</div>
						<div className="col-12 col-md-auto col-lg-2">
                        <CheckboxButtonGroup label="Aplica">
                            <CheckboxButton
                                name="aplicaDerechosEspontaneos"
                                label="Derechos espontáneos"
                                checked={formValues.aplicaDerechosEspontaneos}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                            {/*<CheckboxButton
                                name="aplicaCancelacionAnticipada"
                                label="Cancelación anticipada"
                                checked={formValues.aplicaCancelacionAnticipada}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />*/}
                        </CheckboxButtonGroup>
                    </div>
                    </>}
                    {formValues.aplicaDeudaAdministrativa &&
                    <div className="col-12 col-md-auto col-lg-2">
                        <CheckboxButtonGroup label="Incluye">
                        <CheckboxButton
                            name="incluyeDeudaNoVencida"
                            label="Deuda NO vencida"
                            checked={formValues.incluyeDeudaNoVencida}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        </CheckboxButtonGroup>
                    </div>}
                    <Tasas
                        tasas={otherValues.planPagosDefinicionAlcanceTasa}
                        setTasas={data => setOtherValues(prev => ({...prev, planPagosDefinicionAlcanceTasa: data}))}
                        params={params}
                        setPendingChange={setPendingChange}
                    />
                </div>
            </div>
        )}
    </>
}

export default CondicionesAplicacion
